import { render, staticRenderFns } from "./myChoiceTransfer.vue?vue&type=template&id=6e169b66&scoped=true"
import script from "./myChoiceTransfer.vue?vue&type=script&lang=js"
export * from "./myChoiceTransfer.vue?vue&type=script&lang=js"
import style0 from "./myChoiceTransfer.vue?vue&type=style&index=0&id=6e169b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e169b66",
  null
  
)

export default component.exports